module.exports = __webpack_public_path__ + "img/Logo.2d7f0ab7.png";